const address2Optional = "Address 2 (optional)"
const fieldRequired = "This field is required."

export const ADDRESS_TRANSLATIONS = {
    cs: {
        address1Label: "Adresa",
        address1RequiredMessage: "Povinný údaj",
        address2Label: "Adresa č.2: (volitelná)",
        address2RequiredMessage: "Povinný údaj"
    },
    da: {
        address1Label: "Adresse",
        address1RequiredMessage: "Dette felt skal udfyldes.",
        address2Label: "Alternativ Adresse: (valgfrit)",
        address2RequiredMessage: "Dette felt skal udfyldes."
    },
    de: {
        address1Label: "Straße, Nr.",
        address1RequiredMessage: "Dieses Feld muss ausgefüllt werden.",
        address2Label: "Zeile 2 (optional)",
        address2RequiredMessage: "Dieses Feld muss ausgefüllt werden."
    },
    en: {
        addressInvalidMessage: 'The address you have entered contains invalid characters.',
        address1Label: "Address Line One",
        address1Placeholder: 'Street Address Line 1',
        address1RequiredMessage: 'Please enter Street Address Line 1',
        address2Label: "Address Line Two (optional)",
        address2Placeholder: 'Street Address Line 2'
    },
    en_DE: {
        address1Label: "Address",
        address2Label: address2Optional
    },
    en_ES: {
        address1Label: "Address",
        address2Label: address2Optional
    },
    en_FR: {
        address1Label: "Address",
        address2Label: address2Optional
    },
    en_GB: {
        address1Label: "Street and number",
        address2Label: "Building, flat, floor, suite, unit (optional)"
    },
    en_HK: {
        address1Label: "Address (Room, Floor, Building)",
        address2Label: "Address (Court, Street)"
    },
    en_HU: {
        address1Label: "Address",
        address2Label: address2Optional
    },
    en_NO: {
        address1Label: "Address",
        address2Label: address2Optional
    },
    en_NZ: {
        address1Label: "Address Line One (Street/PO Box)"
    },
    en_ZA: {
        address1Label: "Street Name and No",
        address1Placeholder: 'Street Name and No',
        address1RequiredMessage: 'Please enter Street Name and No',
        address2Label: "Complex Name and No",
        address2Placeholder: "Complex Name and No"
    },
    es: {
        address1Label: 'Dirección Línea 1',
        address1Placeholder: 'Dirección Línea 1',
        address1RequiredMessage: 'Por favor ingrese la línea de dirección de la calle 1.',
        address2Label: 'Dirección Línea 2',
        address2Placeholder: 'Dirección Línea 2',
        addressInvalidMessage: 'La dirección que ingresó contiene caracteres no válidos.'
    },
    fi: {
        address1Label: "Osoite",
        address1RequiredMessage: "Tämä kenttä on pakollinen.",
        address2Label: "Osoiterivi2: (valinnainen)",
        address2RequiredMessage: "Tämä kenttä on pakollinen."
    },
    fr: {
        address1Label: "Adresse",
        address1RequiredMessage: "Ceci est un champ obligatoire.",
        address2Label: "Adresse 2: (facultative)",
        address2RequiredMessage: "Ceci est un champ obligatoire."
    },
    fr_NC: {
        address1Label: "Adresse (Street/PO Box)"
    },
    hu: {
        address1Label: "Cím",
        address1RequiredMessage: "E mező kitöltése kötelező.",
        address2Label: "Cím 2 (választható)",
        address2RequiredMessage: "E mező kitöltése kötelező."
    },
    in: {
        address1Label: "Address Line One (Maks. 40 Karakter)",
        address1RequiredMessage: fieldRequired,
        address2Label: "Address Line Two (optional) (Maks. 35 Karakter)",
        address2RequiredMessage: fieldRequired
    },
    is: {
        address1Label: "Heimilisfang",
        address1RequiredMessage: "Þessa eyðu má ekki skilja eftir auða.",
        address2Label: "Heimilisfang 2 (valfrjálst)",
        address2RequiredMessage: "Þessa eyðu má ekki skilja eftir auða."
    },
    it: {
        address1Label: "Indirizzo",
        address1RequiredMessage: "Questo è un campo obbligatorio.",
        address2Label: "Indirizzo 2: (opzionale)",
        address2RequiredMessage: "Questo è un campo obbligatorio."
    },
    iw: {
        address1Label: "שורת כתובת ראשונה",
        address1RequiredMessage: fieldRequired,
        address2Label: "שורת כתובת שנייה (אופציונלי)",
        address2RequiredMessage: fieldRequired
    },
    ja: {
        addressInvalidMessage: '特殊文字は使用できません',
        address1Label: "市区町村以下： （続き）",
        address1RequiredMessage: "この項目は必須です。"
    },
    ms: {
        address1Label: "Address Line One",
        address1RequiredMessage: fieldRequired,
        address2Label: "Address Line Two (optional)",
        address2RequiredMessage: fieldRequired
    },
    nl: {
        address1Label: "Adres",
        address1RequiredMessage: "Dit veld is verplicht.",
        address2Label: "Adres 2: (optioneel)",
        address2RequiredMessage: "Dit veld is verplicht."
    },
    no: {
        address1Label: "Adresse",
        address1RequiredMessage: "Dette er et obligatorisk felt.",
        address2Label: "Adresse2: (valgfri)",
        address2RequiredMessage: "Dette er et obligatorisk felt."
    },
    pl: {
        address1Label: "Adres",
        address1RequiredMessage: "To pole należy obowiązkowo wypełnić.",
        address2Label: "Adres 2: (opcjonalnie)",
        address2RequiredMessage: "To pole należy obowiązkowo wypełnić."
    },
    pt: {
        address1Label: "Endereço - Linha 1",
        address1RequiredMessage: "Campo é obrigatório",
        address2Label: "Endereço - Linha 2 (opcional)",
        address2RequiredMessage: "Campo é obrigatório"
    },
    ro: {
        address1Label: "Adresa Linia 1",
        address1RequiredMessage: "Acest câmp este obligatoriu.",
        address2Label: "Adresa linia 2 (opţional)",
        address2RequiredMessage: "Acest câmp este obligatoriu."
    },
    ru: {
        address1Label: "Улица, дом, корпус, квартира",
        address1RequiredMessage: "Это поле обязательно для заполнения."
    },
    sk: {
        address1Label: "Adresa",
        address1RequiredMessage: "Je potrebné vyplniť toto pole.",
        address2Label: "Adresa (voliteľné)",
        address2RequiredMessage: "Je potrebné vyplniť toto pole."
    },
    sv: {
        address1Label: "Adress",
        address1RequiredMessage: "Detta fält måste ifyllas.",
        address2Label: "Adress 2: (frivilligt)",
        address2RequiredMessage: "Detta fält måste ifyllas."
    },
    th: {
        address1Label: "ที่อยู่",
        address1RequiredMessage: "กรุณากรอกข้อมูลนี้ให้ครบถ้วน",
        address2Label: "ที่อยู่ 2: (ตัวเลือก)",
        address2RequiredMessage: "กรุณากรอกข้อมูลนี้ให้ครบถ้วน"
    },
    th_SE: {
        address1RequiredMessage: "จำเป็นต้องกรอกช่องนี้",
        address2RequiredMessage: "จำเป็นต้องกรอกช่องนี้"
    },
    th_TH: {
        address1Label: "ที่อยู่บรรทัดที่ 1",
        address2Label: "ที่อยู่บรรทัดที่ 2"
    },
    tr: {
        address1Label: "Adres",
        address1RequiredMessage: "Bu alanı doldurmak zorunludur.",
        address2Label: "Adres 2: (Tercihli)",
        address2RequiredMessage: "Bu alanı doldurmak zorunludur."
    },
    uk: {
        address1Label: "Вулиця, будинок, корпус, квартира",
        address1RequiredMessage: "Це поле є обов язковим для заповнення."
    },
    vi: {
        address1Label: "Địa Chỉ",
        address1RequiredMessage: "Trường thông tin bắt buộc",
        address2Label: "Địa Chỉ Dòng Thứ Hai (tùy chọn)",
        address2RequiredMessage: "Trường thông tin bắt buộc"
    },
    zh: {
        address1Label: '街道地址线1',
        address1Placeholder: '街道地址线1',
        address1RequiredMessage: '请输入街道地址1。',
        address2Label: '街道地址线2',
        address2Placeholder: '街道地址线2',
        addressInvalidMessage: '您输入的地址包含无效字符。'
    }
};
